import { defineMessages } from 'react-intl'

/** Flight itinerary, bundle, and transfer copy — `docs/product-taxonomy.md` §9. */
const flightBundleGlossaryMessages = defineMessages({
  oneWayFlight: {
    defaultMessage: 'One-way flight',
    id: 'SRdjvZOxX7rf_vK2McBw',
  },
  returnFlight: {
    defaultMessage: 'Return flight',
    id: 'vqnSw062cxM9wg1Mjg-S',
  },
  returnFlights: {
    defaultMessage: 'Return flights',
    id: 'jN6XHw1Lh70z-2x-Z2Zu',
  },
  multiCityFlights: {
    defaultMessage: 'Multi-city flights',
    id: 'N3Z9FNA7W5fYmUHAE1p0',
  },
  hotelPlusFlights: {
    defaultMessage: 'Hotel + flights',
    id: 'a4BjYJlsyVFO5AJazG9p',
  },
  hotelAndFlightBundle: {
    defaultMessage: 'Hotel & Flight bundle',
    id: 'on4XJ5cWSnaVM4s44ARw',
  },
  nightsAndFlights: {
    defaultMessage: '{nights, plural, one {# night} other {# nights}} & flights',
    id: 'w39lt_oE4_A4m6LnUWef',
  },
  nightsPlusFlightsFrom: {
    defaultMessage: '{nights, plural, one {# night} other {# nights}} + flights from',
    id: 'nEKSV2XrcU3nmYSEZ6l2',
  },
  freeRoundTripTransfers: {
    defaultMessage: 'Free round-trip transfers',
    id: 'U-MIrKy8aaqAwDEBL3uy',
  },
  roundTripTransfers: {
    defaultMessage: 'Round-trip transfers',
    id: 'xIDgrYolg8pSsPgrif3x',
  },
  privateTransport: {
    defaultMessage: 'Private Transport',
    id: 'j_QT9Vo94tJjiFeW5caN',
  },
  hotelTransfer: {
    defaultMessage: 'Hotel Transfer',
    id: '4zcINLoZJbs6aXEbbWCq',
  },
  flightDetails: {
    defaultMessage: 'Flight details',
    id: 'wkQ6ZxhHUkd_e7nRF3YT',
  },
  flightNumber: {
    defaultMessage: 'Flight number',
    id: 'EOqOr68c1Ex0t-KQE-PG',
  },
  searchFlights: {
    defaultMessage: 'Search flights',
    id: 'xJFt7wa_gx9pbtdb5F6J',
  },
  selectFlights: {
    defaultMessage: 'Select flights',
    id: '4BpwHoJJFR3CS0iVD5zv',
  },
  noFlightsAvailable: {
    defaultMessage: 'No flights available',
    id: '8OOg65fPf5tRtvXy9t07',
  },
  makeFlightFullyRefundable: {
    defaultMessage: 'Make your flight fully refundable',
    id: 'VKsNF3BDk6ZRctC-CI0c',
  },
  fullyRefundableFlights: {
    defaultMessage: 'Fully refundable flights',
    id: 'WfapLERCmEO8dw7u7yXV',
  },
  directMaldivesFlights: {
    defaultMessage: 'Direct Maldives Flights',
    id: 'Zafi41TE3h7k8mobnIU5',
  },
  leMaldivesCharter: {
    defaultMessage: 'Luxury Escapes Exclusive Service',
    id: 'q7z2RQGjvN1bfL20IE1g',
  },
})

export default flightBundleGlossaryMessages
